// src/components/MenuModal/MenuModal.js
import { motion, AnimatePresence } from 'framer-motion';
import { FiHome, FiDollarSign, FiTruck, FiFileText, FiTool, FiCalendar, FiPackage } from 'react-icons/fi';
import { GiPianoKeys, GiWoodCabin, GiHomeGarage, GiScrew } from 'react-icons/gi';
import '../../../assets/css/menu.css';
import { LuBug } from "react-icons/lu";
import { FiSettings } from "react-icons/fi";
import { FaCogs } from "react-icons/fa";
import { GiWoodBeam } from "react-icons/gi";
import { GiWoodFrame } from "react-icons/gi";
import { MdOutlineContactSupport } from "react-icons/md";
import { GiGrandPiano } from "react-icons/gi";






const MenuModal = ({ isOpen, onClose }) => {
  const menuItems = [
    { icon: <FiHome />, label: 'Home', link: '/' },
    { icon: < GiGrandPiano/>, label: 'Pianos à Venda', link: '/pianos' },
    { icon: <GiWoodBeam  />, label: 'Restauração do Móvel', link: '/restauracao-movel' },
    { icon: <LuBug />, label: 'Descupinização', link: '/descupinizacao' },
       { icon: <GiScrew />, label: 'Conserto de Cravelhas', link: '/conserto-cravelhas' },
          { icon: <FiSettings />, label: 'Regulagem', link: '/regulagem' },
           { icon: <FaCogs  />, label: 'Reforma do Mecanismo', link: '/reforma-mecanismo' },
            { icon: <GiPianoKeys />, label: 'Restauração do Teclado', link: '/restauracao-teclado' },
             { icon: <GiWoodFrame />, label: 'Serviço de Marcenaria', link: '/marcenaria' },
             { icon: <FiTruck />, label: 'Transporte', link: '/transporte' },
             { icon: <FiPackage />, label: 'Armazenagem', link: '/armazenagem' },
             { icon: <FiCalendar />, label: 'Aluguel', link: '/aluguel' },
             { icon: <FiFileText />, label: 'Consignação', link: '/consignacao' },
               { icon: <FiDollarSign />, label: 'Compramos seu Piano', link: '/compra' },
               { icon: < MdOutlineContactSupport />, label: 'Orçamento/Contato', link: '/orcamento' }
              
  
    
    
    
 
   
   
 
    
   
   
    
    
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="modal-content"
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={onClose}>
              &times;
            </button>
            
            <ul className="menu-list">
              {menuItems.map((item, index) => (
                <motion.li
                  key={item.link}
                  className="menu-item"
                  initial={{ x: 50, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ 
                    delay: 0.05 * index,
                    type: 'spring',
                    stiffness: 100
                  }}
                >
                  <a href={item.link} className="menu-link">
                    {item.icon}
                    {item.label}
                  </a>
                </motion.li>
              ))}
            </ul>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MenuModal;